<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-spacer></v-spacer>
      <v-btn icon @click="addDate(-1)"><v-icon>keyboard_arrow_left</v-icon></v-btn>

      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-left="65"
        :nudge-bottom="10"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on"
            ><span class="title">{{ $filters.date(date, "DD.MM.YYYY") }}</span></v-btn
          >
        </template>
        <v-date-picker
          no-title
          scrollable
          prev-icon="keyboard_arrow_left"
          next-icon="keyboard_arrow_right"
          v-model="datepicker"
          @input="getDatepicker"
          locale="de-de"
        ></v-date-picker>
      </v-menu>

      <v-btn icon @click="addDate(1)"><v-icon>keyboard_arrow_right</v-icon></v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>

    <v-row class="mt-1">
      <v-col cols="12" class="pa-0 my-1">
        <v-card outlined class="pa-2 ma-0">
          <v-row no-gutters class="ma-0 pa-0">
            <v-col cols="12" sm="7" md="6" class="pr-1 mb-2">
              <v-autocomplete
                dense
                hide-details
                outlined
                label="Bundesbruder"
                :items="bundesbruderselect"
                v-model="bbrID"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" class="hidden-sm-and-up pr-1 mb-2">
              <v-btn outlined @click="stricheSet(-1)">-1</v-btn>
            </v-col>
            <v-col cols="6" sm="3" md="4" class="pr-1 mb-2">
              <v-text-field
                dense
                hide-details
                outlined
                min="0"
                class="feld"
                type="number"
                name=""
                label="Striche"
                id=""
                v-model="striche"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="hidden-sm-and-up pr-1 mb-2">
              <v-btn outlined @click="stricheSet(+1)">+1</v-btn>
            </v-col>
            <v-col cols="6" sm="2" md="2" class="pr-1 mb-2">
              <v-btn tabindex="-1" block height="40px" outlined @click="showStrichpreis = true"
                >Strichpreis<br />{{ strichpreis | money }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pr-1 mb-2">
              <v-autocomplete
                dense
                hide-details
                outlined
                clearable
                @input="anzahlEkp = 1"
                label="EKP-Getränke"
                :items="getrankeselect"
                v-model="ekp"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" sm="4" md="2" class="pr-1 mb-2">
              <v-text-field
                dense
                hide-details
                outlined
                min="0"
                class="feld"
                type="number"
                name=""
                label="Anzahl"
                id=""
                v-model="anzahlEkp"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="3" md="2" class="pr-1 mb-2">
              <v-text-field
                dense
                hide-details
                append-icon="euro"
                outlined
                class="feld"
                name=""
                label="Pauschal"
                id=""
                v-model="pauschal"
              ></v-text-field>
            </v-col>
            <v-col cols="8" sm="5" md="3" class="pr-1 mb-2">
              <v-text-field
                dense
                :hint="pauschal && !grund ? 'Du musst einen Grund für den Pauschalpreis angeben.' : ''"
                hide-details="auto"
                outlined
                class="feld"
                name=""
                label="Grund"
                id=""
                v-model="grund"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="text-left">
              <v-btn block height="40px" :disabled="!bbrID" class="primary" :dark="!!bbrID" @click="saveStriche"
                ><v-icon>save</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" class="px-0 my-1">
        <v-card outlined>
          <v-simple-table dense fixed-header height="calc(100vh - 504px)">
            <thead>
              <tr>
                <th>Name</th>
                <th>Was</th>
                <th width="100px" class="text-right">Preis</th>
                <th width="100px" class="text-right">Anzahl</th>
                <th width="100px" class="text-right">Gesamt</th>
                <th width="20px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in stricheHeute" :key="item.name">
                <td>{{ item.bbr }}</td>
                <td class="hidden-xs-only">{{ item.grund }}</td>
                <td class="text-right">{{ item.preis | money }}</td>
                <td class="text-right">{{ item.anzahl }}</td>
                <td class="text-right">{{ (item.preis * item.anzahl) | money }}</td>
                <td v-if="item.id" @click="deleteStrich(item.id)">
                  <v-btn icon><v-icon>delete</v-icon></v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-toolbar dense flat>
      <v-spacer></v-spacer>
      {{ strichAnzahl }} Striche -
      {{ summe | money }}
    </v-toolbar>

    <v-dialog v-model="showStrichpreis" width="30%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
        <v-card-title>
          <div>Strichpreis festlegen</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showStrichpreis = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-text-field
            label="Strichpreis"
            dense
            outlined
            hint="Der Strichpreis wird für spätere Eintäge gespeichert."
            persistent-hint
            v-model="strichpreisNeu"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="showStrichpreis = false">Schließen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="saveStrichpreis()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        date: new Date(),
        datepicker: new Date().toISOString().substr(0, 10),
        pauschal: "",
        striche: "",
        getrankeselect: [],
        grund: "",
        bbrID: "",
        ekp: [],
        anzahlEkp: "",
        menu: false,
        strichAnzahl: 0,
        showStrichpreis: false,
        strichpreisNeu: 0,
      };
    },
    computed: {
      strichpreis() {
        let strichpreis = this.$store.getters["einstellungen/einstellung"]("strichpreis");
        if (strichpreis) {
          return strichpreis.strichpreis;
        } else {
          return "";
        }
      },
      summe() {
        let summe = 0;
        this.strichAnzahl = 0;
        this.stricheHeute.forEach((strich) => {
          if (strich.art === "strich") {
            summe += parseFloat(strich.preis) * parseInt(strich.anzahl);
            this.strichAnzahl += parseInt(strich.anzahl);
          }
          if (strich.art === "ekp") {
            summe += parseFloat(strich.preis);
          }
          if (strich.art === "pauschal") {
            summe += parseFloat(strich.preis);
          }
        });
        return summe;
      },
      stricheHeute() {
        if (this.$store.state.striche.loaded === false) {
          this.$store.dispatch("striche/loadStriche");
        }
        let striche = [];
        this.$store.state.striche.striche.forEach((strich) => {
          let date = new Date(new Date(strich.date.seconds * 1000).setHours(0, 0, 0, 0));
          this.date = new Date(this.date.setHours(0, 0, 0, 0));
          if (date - this.date === 0) {
            let bbr = this.$store.getters["bbrbbr/bbr"](strich.bbrID);
            strich.bbr = bbr.nachname + ", " + bbr.vorname;
            striche.push(strich);
          }
        });
        return striche;
      },
      bundesbruderselect() {
        let items = this.$store.state.bbrbbr.bbrbbr;
        let bbrbbr = [];
        items.forEach((item) => {
          if (item.vulgo) {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")",
            });
          } else {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname,
            });
          }
        });
        return bbrbbr;
      },
    },
    methods: {
      stricheSet(value) {
        if (!this.striche) {
          this.striche = 0;
        }
        if (this.striche + value >= 0) {
          this.striche = parseInt(this.striche) + parseInt(value);
        }
      },
      deleteStrich(value) {
        this.$store.dispatch("striche/deleteStrichData", value);
      },
      addDate(value) {
        this.date = new Date(this.date.setDate(this.date.getDate() + value));
      },
      getDatepicker() {
        this.date = new Date(this.datepicker);
        this.datepicker = new Date(this.date).toISOString().substr(0, 10);
        this.menu = false;
      },
      saveStriche() {
        if (this.bbrID) {
          // Striche werden eingetragen
          if (this.striche) {
            const striche = {
              bbrID: this.bbrID,
              art: "strich",
              date: this.date,
              preis: this.strichpreis,
              anzahl: this.striche,
              status: "",
              grund: "Strich",
            };
            this.$store.dispatch("striche/createStrich", striche);
          }
          // Einkaufspreis wird eingetragen
          if (this.ekp.length > 0) {
            const ekp = {
              bbrID: this.bbrID,
              art: "ekp",
              ekp: this.ekp[0],
              date: this.date,
              preis: this.ekp[0].preis,
              anzahl: 1,
              status: "",
              grund: this.ekp[0].bezeichnung,
            };
            for (this.anzahlEkp; parseInt(this.anzahlEkp) >= 1; this.anzahlEkp--) {
              this.$store.dispatch("striche/createStrich", ekp);
            }
          }
          // Pauschale Kosten
          let preis = parseFloat(this.pauschal.replace(",", ".")).toFixed(2);
          if (this.pauschal) {
            const pauschal = {
              bbrID: this.bbrID,
              art: "pauschal",
              preis: preis,
              date: this.date,
              grund: this.grund,
              anzahl: 1,
              status: "",
            };
            this.$store.dispatch("striche/createStrich", pauschal);
          }
          this.bbrID = "";
          this.striche = "";
          this.ekp = "";
          this.pauschal = "";
          this.grund = "";
          this.anzahlEkp = "";
        } else {
          console.log("Kein Bundesbruder ausgewählt.");
        }
      },
      saveStrichpreis() {
        let item = {
          id: "strichpreis",
          strichpreis: parseFloat(this.strichpreisNeu.replace(",", ".")).toFixed(2),
        };
        this.$store.dispatch("einstellungen/updateEinstellungData", item);
        this.showStrichpreis = false;
      },
    },
    beforeMount() {
      this.$firebase
        .firestore()
        .collection("vereine")
        .doc(this.$vars.verbindung)
        .collection("getranke")
        .orderBy("bezeichnung")
        .onSnapshot(
          (querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().switchEkp) {
                this.getrankeselect.push({
                  value: [
                    {
                      id: doc.id,
                      preis: doc.data().verkauf1,
                      bezeichnung: doc.data().bezeichnung,
                    },
                  ],
                  text: doc.data().bezeichnung,
                });
              }
            });
          },
          (err) => {
            console.log(`Encountered error: ${err}`);
          }
        );
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// stricheNeu.vue?34259cbf